import { IUserPublicProfile } from '@koopajs/app';

export const alphabeticalUserSortFunction = (a: IUserPublicProfile, b: IUserPublicProfile): number => {
  const userA: string = a.username || '';
  const userB: string = b.username || '';
  return userA.localeCompare(userB, 'en', { sensitivity: 'base' });
};
